import React from 'react'
import { PageChangeEvent, Pager } from '@progress/kendo-react-data-tools'
import { Contents } from './Contents'

import './HistoryBody.css'
import { StackLayout } from '@progress/kendo-react-layout'

export interface HistoryBodyProps {
  body?: React.ReactNode
  footerButton?: React.ReactNode
  total?: number
  changeSkip?: React.Dispatch<React.SetStateAction<number>>
  skip?: number
}

export function HistoryBody(props: HistoryBodyProps) {
  /*
   *  take  1ページのデータ数
   */
  const [take, setTake] = React.useState(20)

  /* リスニングページング */
  const handlePageChange = (event: PageChangeEvent) => {
    if (props.changeSkip !== undefined) {
      props.changeSkip(event.skip)
    }
    setTake(event.take)
  }
  return (
    <div className="pcy-history-body">
      <div className="pcy-history-body-content">
        <Contents>
          {props.body}
          <Pager
            total={props.total !== undefined ? props.total : 1000}
            skip={props.skip !== undefined ? props.skip : 0}
            take={take}
            onPageChange={handlePageChange}
            previousNext
            responsive
            className="pcy-history-body-pager k-pager-wrap"
          />
        </Contents>
      </div>
      <div className="pcy-search-body-pane-footer pcy-control-box">
        <StackLayout gap={5} align={{ horizontal: 'end' }}>
          {props.footerButton}
        </StackLayout>
      </div>
    </div>
  )
}
